import { render, staticRenderFns } from "./ParsingTagsView.vue?vue&type=template&id=e139766e&scoped=true&"
import script from "./ParsingTagsView.vue?vue&type=script&lang=js&"
export * from "./ParsingTagsView.vue?vue&type=script&lang=js&"
import style0 from "./ParsingTagsView.vue?vue&type=style&index=0&id=e139766e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e139766e",
  null
  
)

export default component.exports